import React, { useEffect, useState } from 'react';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import NotFoundPage from './pages/NotFoundPage';
import { Toaster } from './toaster';
import './index.css';

function App() {
  const [path, setPath] = useState(
    typeof window !== 'undefined' ? window.location.pathname : '/'
  );
  const isFAQPath = path === '/faq' || path === '/faq/';

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener('popstate', updatePath);
    window.addEventListener('app:navigate', updatePath as EventListener);
    return () => {
      window.removeEventListener('popstate', updatePath);
      window.removeEventListener('app:navigate', updatePath as EventListener);
    };
  }, []);

  useEffect(() => {
    if (path !== '/faqs' && path !== '/faqs/') return;

    window.history.replaceState({}, '', '/faq/');
    setPath('/faq/');
  }, [path]);

  return (
    <>
      <Toaster />
      {path === '/' ? <HomePage /> : isFAQPath ? <FAQPage /> : <NotFoundPage />}
    </>
  );
}

export default App;
